import { Component, Host, h } from '@stencil/core';

@Component({
  tag: 'cr-chart-wrapper-lg',
  styleUrl: 'cr-chart-wrapper-lg.css',
  shadow: true,
})
export class CrChartWrapperLg {

  render() {
    return (
      <Host>
        <bx-tile><slot /></bx-tile>
      </Host>
    );
  }

}
